/* ─── Field wrapper ─── */

.field {
  display: inline-flex;
  align-items: center;
  gap: var(--space-3);
  cursor: pointer;
}

.field[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

.field[data-disabled] .root {
  opacity: 1;
}

/* ─── Track ─── */

.root {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 3.25rem;
  height: 2rem;
  padding: 0.4375rem;
  border-radius: var(--shape-full);
  border: none;
  background: var(--md-surface-container-highest);
  cursor: inherit;
  box-sizing: border-box;
  flex-shrink: 0;
  transition: background var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.root[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

.root[data-checked] {
  background: var(--md-primary);
}

.root:focus-visible {
  --focus-ring-offset: var(--focus-ring-offset-outset);
}

/* ─── Thumb ─── */

.thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: var(--shape-full);
  background: var(--md-outline);
  transition: transform var(--motion-duration-short3)
      var(--motion-easing-standard),
    width var(--motion-duration-short3) var(--motion-easing-standard),
    height var(--motion-duration-short3) var(--motion-easing-standard),
    background var(--motion-duration-short3) var(--motion-easing-standard);
}

.root[data-checked] .thumb {
  transform: translateX(1.25rem);
  background: var(--md-on-primary);
  width: 1.375rem;
  height: 1.375rem;
}

/* ─── Label ─── */

.label {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  cursor: inherit;
  user-select: none;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
  margin: 0;
}
